import { render, staticRenderFns } from "./ProductPricingPlanItem.vue?vue&type=template&id=13a713ef&scoped=true"
import script from "./ProductPricingPlanItem.vue?vue&type=script&lang=js"
export * from "./ProductPricingPlanItem.vue?vue&type=script&lang=js"
import style0 from "./ProductPricingPlanItem.vue?vue&type=style&index=0&id=13a713ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a713ef",
  null
  
)

export default component.exports